import { ref, Ref, onMounted, watch, computed } from "vue";
import quotes from "@/assets/quotes";
import QuoteSteps from "@/utils/QuotesSteps";
import { Quote } from "@/models/Quote";

// currentStep.value = quote.value.currentStep;

// const currentStep = ref("");
//Order is important
const menuQuoteSteps = [
  QuoteSteps.INTRODUCTION,
  QuoteSteps.QUESTIONS,
  QuoteSteps.QUOTE,
  QuoteSteps.ADDON,
  QuoteSteps.ACCOUNT,
  QuoteSteps.CHECKOUT,
  QuoteSteps.REVIEW,
  QuoteSteps.DONE,
];

export default (currentStep: Ref<string>) => {
  const wizardComponent = ref("");
  const wizardTitle = ref("");
  const nextStep = ref("");

  // let currentStep = "";
  // const onModalMounted = (modalName: string): Ref<string | null> => {

  onMounted(() => {
    quoteNext(currentStep.value);
  });

  watch(currentStep, (newQuote) => {
    quoteNext(currentStep.value);
  });
  // }

  /**
   * Next event from a wizard page.
   */
  const quoteNext = (command: string) => {
    if (command) {
      const newQuote = quotes[command];
      wizardComponent.value = newQuote?.wizardComponent;
      wizardTitle.value = newQuote?.wizardTitle;
    }
  };

  const getNextStep = (command: string) => {
    const index = quotes[command].index + 1;
    return menuQuoteSteps[index];
  };

  const getStepIndex = () => {
    if (currentStep) {
      return menuQuoteSteps.findIndex((s) => s == currentStep.value);
    } else {
      return -1;
    }
  };

  const toShowMenuSteps = (): boolean => {
    let toShow = false;
    if (getStepIndex()) {
      toShow = true;
    }
    return toShow;
  };

  const toShowMobileCart = (): boolean => {
    let toShow = false;
    const index = getStepIndex();
    if (index > 0 && index < 7) {
      toShow = true;
    }
    return toShow;
  };

  function redirectToLoginPage() {
    const index = getStepIndex();
    if (index > 4 && index < 10) {
      quoteNext("quote-account");
    }
  }

  return {
    menuQuoteSteps,
    quoteNext,
    wizardComponent,
    wizardTitle,
    getNextStep,
    toShowMobileCart,
    toShowMenuSteps,
    redirectToLoginPage,
  };
};
